import axios from 'axios';

import { store } from './store';
import authActions from './auth/actions';
import { getToken } from '../helpers/utility';
import { AuthError } from '../customApp/errors/authError';
import { APIError } from '../customApp/errors/apiError';
import { API_STATUS_CODE_SUCCESS } from '../customApp/constants';

export default () =>
  new Promise((resolve, reject) => {
    try {
      store.dispatch(authActions.checkAuthorization());
      axios.defaults.timeout = process.env.REACT_APP_API_TIMEOUT ?? 20000;
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      axios.interceptors.request.use(
        config => {
          const mutatedConfig = config;
          const apiToken = getToken().get('apiToken');
          if (apiToken) {
            mutatedConfig.headers = {
              Authorization: `Bearer ${apiToken}`,
            };
            return mutatedConfig;
          }
          
          // 安全的 URL 檢查，避免 new URL() 拋出錯誤
          try {
            const parsedUrl = new URL(config.url);
            if (parsedUrl.pathname.endsWith('/api/user/login')) {
              return mutatedConfig;
            }
          } catch (urlError) {
            // 如果 URL 解析失敗，檢查字串是否包含登入路徑
            if (config.url && config.url.includes('/api/user/login')) {
              return mutatedConfig;
            }
          }
          
          throw new AuthError('請重新登入');
        },
        error => Promise.reject(error),
      );
      axios.interceptors.response.use(
        response => {
          const payload = response.data;
          if (payload.status_code !== API_STATUS_CODE_SUCCESS) {
            throw new APIError(payload.message, payload.status_code);
          }
          return response;
        },
        error => Promise.reject(error),
      );
      
      // 重要：Boot 完成後 resolve Promise
      resolve();
    } catch (error) {
      reject(error);
    }
  });
